import Vue from "vue";
import SharedGenericListing from "./SharedGenericListing.vue";

export function load() {
  const selector = "shared-listing-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(SharedGenericListing, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
